export enum CreatePlanStepName {
  PLAN_INFO = 'PLAN_INFO',
  PLAN_DETAILS = 'PLAN_DETAILS',
  DATA_CONTROL = 'DATA_CONTROL',
  VOICE_SMS_CONTROL = 'VOICE_SMS_CONTROL',
  PRICING_INFO = 'PRICING_INFO',
  SUMMARY = 'SUMMARY',
}

// CreatePlanFormStepIndex and CreatePlanStepName must have the same property names
export enum CreatePlanFormStepIndex {
  'PLAN_INFO' = 0,
  'PLAN_DETAILS' = 1,
  'DATA_CONTROL' = 2,
  'VOICE_SMS_CONTROL' = 3,
  'PRICING_INFO' = 4,
  'SUMMARY' = 5,
}
